import React, { useState, useEffect } from 'react';
import { Grid, Chip, Typography, InputLabel, Select, MenuItem } from '@mui/material';
import { LabelLine } from 'components/InputV2/components';
import createToast from 'components/Toast/Toast';
import { useForm, FormProvider } from 'react-hook-form';
import UploadFiles from 'components/UploadFile';
import { InputV2, ButtonLoading, HeaderSection, CommonTooltip, LoadingPage, Icons, InputCurrency } from 'components';
import { useStyles } from './Style';
import Services from '../../services/Services';
import AddAgentDg from '../AddAgentDg';
import AddSponsorDg from '../AddSponsorDg';
import MessageDg from '../MessageDg';
import { formatPrice } from 'utility';
import { useCurrencyUnit } from 'hooks';
const RequestCompleteDetailStepTwo = (props) => {
  const { typeWarranty, price, lastData = null, isEnable = true, phoneNumber = '***' } = props;
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const methods = useForm();
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [selectedAccountTradition, setSelectedAccountTradition] = useState(null);
  const [creditList, setCreditList] = useState([]);
  const [traditionalAccountList, setTraditionalAccountList] = useState([]);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [validationPrice, setValidationPrice] = useState('');

  const [isOpenAgentDg, setIsOpenAgentDg] = useState(false);
  const [isOpenSponsorDg, setIsOpenSponsorDg] = useState(false);
  const [isOpenMessageDg, setIsOpenMessageDg] = useState(false);
  const [fileHash, setFileHash] = useState(null);
  const [fileURL, setFileURL] = useState(null);
  const [formData, setFormData] = useState(null);
  const [agentList, setAgentList] = useState([]);
  const [sponsorList, setSponsorList] = useState([]);
  const currencyText = useCurrencyUnit(false);
  useEffect(() => {
    if (currencyText) {
      getData();
    }

  }, [currencyText]);

  useEffect(() => {
    if (
      methods.formState.errors &&
      Object.keys(methods.formState.errors).length > 0 &&
      methods.formState.submitCount > 0
    ) {
      createToast('خطا', errorsToStr(methods.formState.errors), 'danger');
    }
  }, [methods.formState.submitCount]);
  const errorsToStr = (errs) => {
    if (!errs) return null;
    return (
      <div>
        {Object.keys(errs).map((v) => (
          <li>{errs[v]?.message}</li>
        ))}
      </div>
    );
  };

  /**
   * بررسی میشود اگر کاربر به این صفحه منتقل شد فیلدهای پیشفرض پر شود
   */
  const checkEdit = (loadLegalCustomers) => {
    if (lastData) {
      const obj = {
        amount: lastData?.source?.amount,
        date: lastData?.source['warranty-duration'],
        fileHash: String(lastData?.source['file-hash']).split('/').reverse()[0],
        fileURL: String(lastData?.source['url']),
        holderAddress: lastData?.source['stakeholder-address'],
        holderName: lastData?.source['stakeholder-name'],
        holderPostalCode: lastData?.source['stakeholder-postal-code'],
        loadLegalCustomersList: lastData?.source['load-legal-customers-list'],
        stackHolder: lastData?.source['stakeholder-national-code'],
        walletNo: lastData?.source['wallet-no'],
        warrantyType: lastData?.source['warranty-type'],
        deposit: lastData?.source?.deposit,
        accountTraditional: lastData?.source?.deposit?.['deposit-iban'],
      };

      methods.setValue('account', obj?.walletNo);
      setSelectedAccount(obj?.walletNo);

      setSelectedAccountTradition(obj?.accountTraditional);
      methods.setValue('accountTraditional', obj?.accountTraditional);

      methods.setValue('fileHash', obj?.fileHash);
      setFileHash([{ name: 'گواهی شرکت در مناقصه', hash: obj?.fileHash, url: obj?.fileHash }]);
      setFileURL(obj?.fileURL);

      const loadData = lastData?.source['load-legal-customers-list'];
      let copyLoadLegalCustomers = JSON.parse(JSON.stringify(loadLegalCustomers));
      if (loadData && copyLoadLegalCustomers) {
        for (let i = 0; i < loadData.length; i++) {
          const element = loadData[i];
          for (let item of copyLoadLegalCustomers) {
            if (item['relatedCustomerNationalCode'] == element['relatedCustomerNationalCode']) {
              item['isSelected'] = true;
            }
          }
        }
        setAgentList([...copyLoadLegalCustomers]);
      }

      const guarantor = lastData?.source['guarantor-legal-customers-list'];
      let copyguarantor = JSON.parse(JSON.stringify(loadLegalCustomers));
      if (guarantor && copyguarantor) {
        for (let i = 0; i < guarantor.length; i++) {
          const element = guarantor[i];
          for (let item of copyguarantor) {
            if (item['relatedCustomerNationalCode'] == element['relatedCustomerNationalCode']) {
              item['isSelected'] = true;
            }
          }
        }
        setSponsorList([...copyguarantor]);
      }

      setFormData(obj);
    }
  };

  /**
   * درخواست ثبت و ویرایش  در زمان کلیک بر روی دکمه ثبت یا ویرایش
   */
  const onSubmit = () => {
    if (!isEnable) {
      createToast('خطا', 'امکان انجام عملیات وجود ندارد', 'danger');

      //navigate('/Warranty/RequestList');
      return;
    }
    const values = methods.getValues();

    //=============================  لیست نماینده ها ===================================================
    if (agentList.filter((a) => a['isSelected'] == true).length < 1) {
      createToast('خطا', 'انتخاب حداقل یک مورد از لیست نماینده ها الزامی است.', 'danger');

      return;
    }
    if (agentList.filter((a) => a['isSelected'] == true).length > 3) {
      createToast('خطا', 'حداکثر 3 نماینده میبایست انتخاب شود.', 'danger');

      return;
    }
    // =============================== لیست ضامنین ========================================
    if (sponsorList.filter((a) => a['isSelected'] == true).length < 1) {
      createToast('خطا', 'انتخاب حداقل یک مورد از لیست ضامنین الزامی است.', 'danger');

      return;
    }
    if (sponsorList.filter((a) => a['isSelected'] == true).length > 5) {
      createToast('خطا', 'حداکثر 5 ضامن میبایست انتخاب شود.', 'danger');

      return;
    }
    if (fileHash === null) {
      createToast('خطا', 'فایل گواهی شرکت در مناقصه بارگذاری نشده است ', 'danger');
      return;
    }

    //==========================================================================================

    if (Number(values?.amount) > Number(price) && typeWarranty === 'PARTICIPATION_TENDERS') {
      // مبلغ در صورتی چک میشود که از نوع صد نقد نباشد - صد نقد در مرحله اول جز گزینه های رادیو باتن است
      createToast(
        'خطا',
        `مبلغ وارد شده نباید بیشتر از ${formatPrice(price, { currency: currencyText })} باشد. `,
        'danger',
      );

      return;
    }
    let obj = fileHash.reduce((a, b) => Object.assign(a, b), {});
    let data = {
      amount: values?.amount,
      'warranty-duration': values?.date,
      'file-hash': obj?.hash,
      fileURL: fileURL,
      'stakeholder-address': values?.holderAddress,
      'stakeholder-name': values?.holderName,
      'stakeholder-postal-code': values?.holderPostalCode,
      'stakeholder-national-code': values?.stackHolder,
      'load-legal-customers-list': agentList.filter((a) => a['isSelected'] == true),
      'guarantor-legal-customers-list': sponsorList.filter((a) => a['isSelected'] == true),
      'wallet-no': selectedAccount,
      'warranty-type': typeWarranty,
      deposit: {
        'deposit-iban': values?.accountTraditional,
        'deposit-number': traditionalAccountList.find(
          (a) => a['deposit-iban'] == values?.accountTraditional,
        )['deposit-number'],
        'deposit-title': traditionalAccountList.find(
          (a) => a['deposit-iban'] == values?.accountTraditional,
        )['deposit-title'],
        'digital-number': creditList.find((a) => a.wallet == selectedAccount)['number'],
      },
    };
    const params = {};
    setIsLoadingSubmit(true);
    if (lastData) {
      // ویرایش
      data['warranty-type'] = formData?.warrantyType;
      Services.editInformationStep2(params, data, lastData?.source['entity-id'])
        .then((res) => {
          createToast('موفق', 'درخواست با موفقیت ثبت شد.', 'success');

          setIsOpenMessageDg(true);
          setIsLoadingSubmit(false);
        })
        .catch((error) => {
          setIsLoadingSubmit(false);
        });
    } else {
      // ایجاد

      Services.sabtInformationStep2(params, data)
        .then((res) => {
          createToast('موفق', 'درخواست با موفقیت ثبت شد.', 'success');

          setIsOpenMessageDg(true);
          setIsLoadingSubmit(false);
        })
        .catch((error) => {
          setIsLoadingSubmit(false);
        });
    }
  };

  /**
   * ولیدشن مبلغ است که کاربر در لحظه ای که مقداری وارد میکند اگر از حد بیشتر وارد کند خطا نمایش میده
   */
  const checkPriceValidation = (val) => {
    if (Number(val) > Number(price)) {
      // مبلغ در صورتی چک میشود که از نوع صد نقد نباشد - صد نقد در مرحله اول جز گزینه های رادیو باتن است
      setValidationPrice(
        `مبلغ وارد شده نباید بیشتر از ${formatPrice(price, { currency: currencyText })} باشد. `,
      );
    } else {
      setValidationPrice('');
    }
  };

  /***
   * دریافت لیست نمایندگان
   * دریافت لیست حساب ها
   * بررسی مشود که اگر به این تب منتقل شده است فیلدهای دیفالت رو پر کند
   */
  const getData = async () => {
    try {
      const credits = await Services.getCredits();
      const loadLegalCustomers = await Services.getLoadLegalCustomers();

      //TODO LIST TRADITIONAL
      const depositList = await Services.getDepositList();
      for (let item of depositList?.result) {
        item['description'] = item['deposit-title'] + '(' + item['deposit-number'] + ')';
      }
      setTraditionalAccountList(depositList?.result);

      const list = credits?.result?.customerAmountSrvs;
      for (let item of list) {
        item['description'] =
          'حساب دیجیتال ' +
          item['walletName'] +
          '(' +
          'قابل برداشت: ' +
          `${formatPrice(price, { currency: currencyText })}` 
          +
          ')';
      }
      setCreditList(list);
      setSelectedAccount(list[0]?.wallet);
      methods.setValue('account', list[0]?.wallet);
      for (const item of loadLegalCustomers.result) {
        item['isSelected'] = false;
      }
      setAgentList(loadLegalCustomers?.result);
      setSponsorList(JSON.parse(JSON.stringify(loadLegalCustomers?.result)));

      checkEdit(loadLegalCustomers?.result);

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setIsError(true);
    }
  };

  return (
    <>
      {isLoading ? (
        <LoadingPage />
      ) : (
        !isError && (
          <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(onSubmit)} noValidate autoComplete="off">
              <Grid container spacing={3}>
                <Grid direction="row" spacing={3} container item xs={12} md={12} lg={6}>
                  <Grid item md={6} xs={12}>
                    <InputCurrency
                      tooltip={
                        typeWarranty === 'PARTICIPATION_TENDERS'
                          ? 'مبلغ ضمانت‌نامه درخواستی را نسبت به درخواست ضمانت‌نامه‌های قبلی و میزان سقف باقیمانده ضمانت‌نامه وارد نمایید.'
                          : null
                      }
                      fullWidth
                      errors={methods.formState.errors}
                      label="مبلغ"
                      name="amount"
                      register={methods.register}
                      rules={['required', 'isNumeric']}
                      onChangeValue={(e) => {
                        // مبلغ در صورتی ولیدیشن چک میشود که از نوع صد نقد نباشد - صد نقد در مرحله اول جز گزینه های رادیو باتن است
                        typeWarranty === 'PARTICIPATION_TENDERS' && checkPriceValidation(e);
                      }}
                      defaultValue={formData?.amount}
                    />
                    {validationPrice && (
                      <span
                        style={{
                          position: 'absolute',
                          color: 'red',
                          fontSize: '11px',
                          marginTop: '-16px',
                        }}
                      >
                        {validationPrice}
                      </span>
                    )}
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputV2
                      errors={methods.formState.errors}
                      name="date"
                      label="مدت اعتبار ضمانت‌نامه (روز)"
                      register={methods.register}
                      fullWidth
                      control={methods.control}
                      rules={['required', 'isNumeric']}
                      defaultValue={formData?.date}
                    />
                  </Grid>

                  <Grid item md={12} xs={12}>
                    <InputLabel shrink className={classes.label} style={{ display: 'flex' }}>
                      <span style={{ color: '#ef5350', margin: '0 4px' }}>*</span>
                      <LabelLine label="انتخاب حساب دیجیتال" />
                    </InputLabel>
                    <Select
                      fullWidth
                      value={selectedAccount}
                      defaultValue={selectedAccount}
                      name="account"
                      onChange={(e) => {
                        setSelectedAccount(e.target.value);
                      }}
                      variant="outlined"
                      required={true}
                      rules={['required']}
                      errors={methods.formState.errors}
                      register={methods.register}
                      style={{ height: 38 }}
                      className="pureSelect"
                    >
                      {creditList.map((item, index) => {
                        return <MenuItem value={item.wallet}>{item.description}</MenuItem>;
                      })}
                    </Select>
                  </Grid>

                  <Grid item md={12} xs={12}>
                    <span style={{ display: 'none' }}>
                      <InputV2
                        errors={methods.formState.errors}
                        name="accountTraditional"
                        label="حساب سنتی"
                        register={methods.register}
                        fullWidth
                        control={methods.control}
                        rules={['required']}
                        defaultValue={formData?.accountTraditional}
                      />
                    </span>
                    <InputLabel shrink className={classes.label} style={{ display: 'flex' }}>
                      <span style={{ color: '#ef5350', margin: '0 4px' }}>*</span>
                      <LabelLine label="انتخاب حساب سنتی" />
                    </InputLabel>
                    <Select
                      fullWidth
                      value={selectedAccountTradition}
                      defaultValue={selectedAccountTradition}
                      //name="accountTraditional"
                      onChange={(e) => {
                        setSelectedAccountTradition(e.target.value);
                        methods.setValue('accountTraditional', e.target.value);
                        methods.clearErrors('accountTraditional');
                      }}
                      variant="outlined"
                      required={true}
                      rules={['required']}
                      errors={methods.formState.errors}
                      register={methods.register}
                      style={{ height: 38 }}
                      className="pureSelect"
                    >
                      {traditionalAccountList.map((item, index) => {
                        return <MenuItem value={item['deposit-iban']}>{item.description}</MenuItem>;
                      })}
                    </Select>

                    <span style={{ color: 'red', fontSize: '11px' }}>
                      {methods?.errors?.accountTraditional?.message}
                    </span>
                  </Grid>

                  <Grid item xs={12}>
                    <HeaderSection title="لیست نماینده ها" />
                  </Grid>

                  <Grid item md={12} xs={12} style={{ display: 'flex' }}>
                    <ButtonLoading
                      type="button"
                      color="primary"
                      variant="outlined"
                      onClick={() => {
                        setIsOpenAgentDg(true);
                      }}
                      name={
                        <>
                          <span style={{ marginLeft: '5px', display: 'flex' }} >
                            <Icons icon='plusCircle' color="#303D8F" size="18" />
                          </span>
                          افزودن نماینده ها
                        </>
                      }
                    />

                    <Grid
                      style={{
                        marginRight: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        direction: 'ltr',
                        opacity: '0.8',
                      }}
                    >


                      <CommonTooltip
                        placement="left"
                        title="از لیست نمایش داده شده، حداقل 1 نفر و حداکثر 3 نفر را به عنوان نماینده انتخاب نمایید. صاحبین امضا انتخابی در قرارداد ذکر خواهد شد و پس از ایجاد قرارداد، لینک امضا الکترونیکی برای آنها ارسال خواهد شد."
                      >
                        <span className={classes.BIIcon}>
                          <Icons icon='Info' color='#667585' hover='#667585' size='20' />
                        </span>
                      </CommonTooltip>
                    </Grid>
                  </Grid>
                  <Grid item md={12} xs={12}>
                    {agentList
                      .filter((a) => a.isSelected)
                      .map((v, k) => (
                        <Chip
                          className={classes.chip}
                          key={k}
                          label={
                            <Typography style={{ fontSize: 12 }}>
                              {v?.relatedCustomerFirstName + ' ' + v?.relatedCustomerLastName}
                            </Typography>
                          }
                          onClick={() => { }}
                          onDelete={() => {
                            v.isSelected = false;
                            setAgentList([...agentList]);
                          }}
                        />
                      ))}
                  </Grid>

                  <Grid item xs={12}>
                    <HeaderSection title="لیست ضامنین" />
                  </Grid>

                  <Grid item md={12} xs={12} style={{ display: 'flex' }}>
                    <ButtonLoading
                      type="button"
                      color="primary"
                      variant="outlined"
                      onClick={() => {
                        setIsOpenSponsorDg(true);
                      }}
                      name={
                        <>
                          <span style={{ marginLeft: '5px', display: 'flex' }} >
                            <Icons icon='plusCircle' color="#303D8F" size="18" />
                          </span>
                          افزودن ضامنین
                        </>
                      }
                    />

                    <Grid
                      style={{
                        marginRight: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        direction: 'ltr',
                        opacity: '0.8',
                      }}
                    >
                      <CommonTooltip
                        placement="left"
                        title="از لیست نمایش داده شده، فقط از اعضای هیئت مدیره با محدودیت حداقل 1 نفر و حداکثر 5 نفر را جهت ضامن انتخاب نمایید."
                      >
                        <span className={classes.BIIcon}>
                          <Icons icon='Info' color='#667585' hover='#667585' size='20' />
                        </span>
                      </CommonTooltip>

                    </Grid>
                  </Grid>
                  <Grid item md={12} xs={12}>
                    {sponsorList
                      .filter((a) => a.isSelected)
                      .map((v, k) => (
                        <Chip
                          className={classes.chip}
                          key={k}
                          label={
                            <Typography style={{ fontSize: 12 }}>
                              {v?.relatedCustomerFirstName + ' ' + v?.relatedCustomerLastName}
                            </Typography>
                          }
                          onClick={() => { }}
                          onDelete={() => {
                            v.isSelected = false;
                            setSponsorList([...sponsorList]);
                          }}
                        />
                      ))}
                  </Grid>

                  <Grid item xs={12}>
                    <HeaderSection title="اطلاعات ذینفع" />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <InputV2
                      fullWidth
                      errors={methods.formState.errors}
                      label="شناسه ملی ذینفع"
                      name="stackHolder"
                      register={methods.register}
                      rules={['required', 'isNumeric', 'isLength|11']}
                      defaultValue={formData?.stackHolder}
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <InputV2
                      fullWidth
                      errors={methods.formState.errors}
                      label="نام ذینفع"
                      name="holderName"
                      register={methods.register}
                      rules={['required']}
                      defaultValue={formData?.holderName}
                    />
                  </Grid>
                  <Grid item md={12} xs={12}>
                    <InputV2
                      fullWidth
                      errors={methods.formState.errors}
                      label="کد پستی"
                      name="holderPostalCode"
                      register={methods.register}
                      rules={['required', 'isNumeric']}
                      defaultValue={formData?.holderPostalCode}
                    />
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <InputV2
                      label="آدرس"
                      multiline
                      fullWidth
                      tooltip="آدرس اعلامی جهت ارسال ضمانت‌نامه درخواستی در صورت امکان  به ذینفع استفاده می‌شود."
                      rows={5}
                      errors={methods.formState.errors}
                      name="holderAddress"
                      register={methods.register}
                      rules={['required']}
                      defaultValue={formData?.holderAddress}
                    />
                  </Grid>

                  <Grid md={12} xs={12} item>
                    <UploadFiles
                      label="گواهی شرکت در مناقصه"
                      tooltip="فرمت فایل ارسالی به صورت jpg ,png ,pdf می‌باشد."
                      hasLink={true}
                      beforeUlpoadList={fileHash}
                      setList={setFileHash}
                      type="WARRANTY"
                      warrantyType="DOCUMENT"
                    />
                  </Grid>

                </Grid>
                <Grid direction="row" container item xs={12} justifyContent='flex-end'>
                  <ButtonLoading
                    type="submit"
                    variant="contained"
                    color="primary"
                    loading={isLoadingSubmit}
                    name={
                      lastData && isEnable ? 'ویرایش و استعلام اطلاعات' : 'ثبت و استعلام اطلاعات'
                    }
                  />
                </Grid>
              </Grid>
            </form>
            <MessageDg
              redirectLink="/Warranty/RequestList"
              isOpenDg={isOpenMessageDg}
              setIsOpenDg={setIsOpenMessageDg}
              title="ثبت درخواست صدور ضمانت‌نامه"
              type="estelam"
            />
            <AddAgentDg
              isOpenAgentDg={isOpenAgentDg}
              setIsOpenAgentDg={setIsOpenAgentDg}
              agentList={agentList}
              setAgentList={setAgentList}
            />
            <AddSponsorDg
              isOpenAgentDg={isOpenSponsorDg}
              setIsOpenAgentDg={setIsOpenSponsorDg}
              agentList={sponsorList}
              setAgentList={setSponsorList}
            />
          </FormProvider>
        )
      )}
    </>
  );
};

export default RequestCompleteDetailStepTwo;
